import { ProjectTypeData } from './types';

export function calculateProjectTypeAllocation(projects: any[], years: string[]): ProjectTypeData[] {
  return years.map(year => {
    const yearProjects = projects.filter((p: any) => p.year === year);
    const totalProjects = yearProjects.length;
    
    const ourIpProjects = yearProjects.filter((p: any) => 
      p.tags.some((t: any) => t.tag.name === 'Our IP')
    );
    
    const ipOpportunityProjects = yearProjects.filter((p: any) => 
      p.tags.some((t: any) => t.tag.name === 'IP Opportunity')
    );

    const otherProjects = yearProjects.filter((p: any) => 
      !p.tags.some((t: any) => 
        t.tag.name === 'Our IP' || t.tag.name === 'IP Opportunity'
      )
    );

    return {
      year,
      ourIp: totalProjects > 0 ? ourIpProjects.length / totalProjects : 0,
      ipOpportunity: totalProjects > 0 ? ipOpportunityProjects.length / totalProjects : 0,
      other: totalProjects > 0 ? otherProjects.length / totalProjects : 0,
      ourIpProjects: ourIpProjects.map((p: any) => p.project_name),
      ipOpportunityProjects: ipOpportunityProjects.map((p: any) => p.project_name),
      otherProjects: otherProjects.map((p: any) => p.project_name)
    };
  });
}